export { default } from './SettingAccessControl';
